import { createSlice } from "@reduxjs/toolkit";

function saveNewOldState(state, nid, nold, un) {
  const obj = {};
  obj["id"] = nid;
  obj["dold"] = nold;
  const nnew=[]
  nid.forEach((id,i)=>{
    nnew.push(state.tt[id]);
  })
  obj["dnew"] = nnew;
  let djy = Object.assign([], state.jy);
  djy = un > 0 ? djy.slice(0, un + 1) : djy;
  djy.push(obj);
  state.jy = djy;
  state.un = 0;
}

const tabplate=createSlice({
    name:"tabplate",
    initialState:{
      t0:0,
      tt:[{nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0},
          {nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0}
        ],
      jy:[{
          id:[0],
          dold:[{
            nu:["0","0","b0b0b0b0b0b0b0b0b0"],
            bj:"0",
            sc:["0","0","0","0","0","0","0","0","0"],
            sh:0
          }],
          dnew:[{
            nu:["0","0","b0b0b0b0b0b0b0b0b0"],
            bj:"0",
            sc:["0","0","0","0","0","0","0","0","0"],
            sh:0
          }]
        }],
      un:0,
      ti:"0",
      btn:""
    },
    reducers:{
      setTabplateStoAll:(state,action)=>{
        const btn=action.payload.btn;
        const t0=action.payload.t0;
        const ti=action.payload.ti;
        const tt=action.payload.tt;

        state.btn=btn;
        state.tt0=t0;
        state.ti=ti
        state.tt=tt
        state.jy=[{
          id:[0],
          dold:[{
            nu:["0","0","b0b0b0b0b0b0b0b0b0"],
            bj:"0",
            sc:["0","0","0","0","0","0","0","0","0"],
            sh:0
          }],
          dnew:[{
            nu:["0","0","b0b0b0b0b0b0b0b0b0"],
            bj:"0",
            sc:["0","0","0","0","0","0","0","0","0"],
            sh:0
          }]
        }];
        state.un=0;
      },
      setTabplateStoBg:(state,action)=>{
        const id=action.payload.id;
        const bj=action.payload.bj;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        //添加背景色
        state.t0=id+1;
        state.tt[id].bj=bj
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      setTabplateStoKo:(state,action)=>{
        const id=action.payload.id;
        const sl=action.payload.sl;
        const sh=action.payload.sh;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].nu[1]=sl
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      setTabplateStoSm:(state,action)=>{
        const id=action.payload.id;
        const sm=action.payload.sm;
        const sc=action.payload.sc;
        const sl=action.payload.sl;
        const sh=action.payload.sh;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].nu[2]=sm
        state.tt[id].sc[sl]=sc
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      setTabplateStoSc:(state,action)=>{
        const id=action.payload.id;
        const sc=action.payload.sc;
        const sh=action.payload.sh;
        const sl=action.payload.sl;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].sc[sl]=sc
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      setTabplateStoHx:(state,action)=>{
        const {nid,nold,nnew,un}=action.payload
        nid.forEach((d,i)=>{
          state.tt[d].nu[2]=nnew[i]
          state.tt[d].sh=3
        })
        saveNewOldState(state, nid, nold, un)
      },
      delTabplateStoKo:(state,action)=>{
        const id=action.payload.id;
        const sl=action.payload.sl;
        const sh=action.payload.sh;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].nu[1]=sl
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      delTabplateStoBg:(state,action)=>{
        const id=action.payload.id;
        const bj=action.payload.bj;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].bj=bj
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      delTabplateStoSc1:(state,action)=>{
        const id=action.payload.id;
        const sc=action.payload.sc;
        const sh=action.payload.sh;
        const sl=action.payload.sl;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].sc[sl]=sc
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      delTabplateStoSc2:(state,action)=>{
        const id=action.payload.id;
        const sca=action.payload.sca;
        const sh=action.payload.sh;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].sc=sca
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      delTabplateStoSc3:(state,action)=>{
        const id=action.payload.id;
        const sh=action.payload.sh;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        const scnew=action.payload.scnew;
        state.t0=id+1;
        nid.forEach((d,i)=>{
          state.tt[d].sc=scnew[i]
        })
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      delTabplateStoSc4:(state,action)=>{
        const id=action.payload.id;
        const sh=action.payload.sh;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].sc=["0","0","0","0","0","0","0","0","0"]
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      delTabplateStoSm:(state,action)=>{
        const id=action.payload.id;
        const sm=action.payload.sm;
        const sc=action.payload.sc;
        const sh=action.payload.sh;
        const sl=action.payload.sl;
        const old=action.payload.old;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=id+1;
        state.tt[id].nu[2]=sm
        state.tt[id].sc[sl]=sc
        state.tt[id].sh=sh
        //保存新旧状态
        saveNewOldState(state, nid, old, un)
      },
      setUndoS:(state,action)=>{
        const nold=action.payload.nold;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=state.jy[un].id[0]+1;
        nid.forEach((id,i)=>{
          state.tt[id]=nold[i];
        })
        state.un=un
      },
      setRedoS:(state,action)=>{
        const nnew=action.payload.nnew;
        const un=action.payload.un;
        const nid=action.payload.nid;
        state.t0=state.jy[un].id[0]+1;
        nid.forEach((id,i)=>{
          state.tt[id]=nnew[i];
        })
        state.un=un
      },
      setZidingStoTi:(state,action)=>{
        const str=action.payload.str;
        const btn=action.payload.btn;
        state.ti=str;
        state.btn=btn;
        state.tt.forEach((v,i)=>{
          const s = str.charAt(i)==="0" ? "0" : "b"+str.charAt(i)
          v.nu[0]=s;v.nu[1]="0";v.nu[2]="b0b0b0b0b0b0b0b0b0";
          v.sh= s==="0" ? 0 : 1;
          v.bj="0";
          v.sc=["0","0","0","0","0","0","0","0","0"]
        });
        state.jy=[{
          id:[0],
          dold:[{
            nu:["0","0","b0b0b0b0b0b0b0b0b0"],
            bj:"0",
            sc:["0","0","0","0","0","0","0","0","0"],
            sh:0
          }],
          dnew:[{
            nu:["0","0","b0b0b0b0b0b0b0b0b0"],
            bj:"0",
            sc:["0","0","0","0","0","0","0","0","0"],
            sh:0
          }]
        }];
        state.un=0
      },
      setButSign:(state,action)=>{
        const btn=action.payload.btn;
        state.btn=btn;
      }
    }
});

export const {setTabplateStoAll,setTabplateStoBg,setTabplateStoKo,setTabplateStoSm,setTabplateStoSc,delTabplateStoKo,delTabplateStoBg,delTabplateStoSc1,delTabplateStoSc2,delTabplateStoSc3,delTabplateStoSc4,delTabplateStoSm,setUndoS,setRedoS,setZidingStoTi,
setTabplateStoHx,setButSign}=tabplate.actions
export default tabplate.reducer